import { authenticationService } from "../services/auth.service";
import { baseService } from "src/store/base.store";
import {User} from "src/entities/user.entity"
type ILogin = {
	email: string,
	password: string,
}
// Define a service using a base URL and expected endpoints
export const authService = baseService.injectEndpoints({
	endpoints: (builder) => ({
		login: builder.mutation<User|null,ILogin>({
			queryFn: async (data) =>{
				try {
					const user= await authenticationService.login(data)
					return { data: user }
				} catch (e: any) {
					const message =
						typeof e?.message === "string" ? e.message : "UNKNOWN_ERROR";
					return { error: { status: "CUSTOM_ERROR", data: { message } } as any }
				}
			}
		}),
		logout: builder.mutation<void, void>({
			queryFn: async () => await authenticationService.logout(),
			// async onQueryStarted(_, { dispatch, queryFulfilled }) {
			// 	try {
			// 		dispatch(
			// 			statisticsService.util.resetApiState()
			// 		)

			// 	} catch {
			// 		console.log('error')
			// 	}
			// }
		}),
	}),
});

export const { useLoginMutation,useLogoutMutation } = authService;
